import { composeIO } from 'react-compose-io'
import { visualizarContabilizacaoIO } from './VisualizarContabilizacao.IO'
import { VisualizarContabilizacaoView } from './VisualizarContabilizacao.View'

const VisualizarContabilizacao = composeIO(VisualizarContabilizacaoView, visualizarContabilizacaoIO)

export default VisualizarContabilizacao
